// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
}

.sub-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
  gap: 20px;
}

/* Upper Section */
.image-container {
  display: flex;
  gap: 80px;
  margin-bottom: 80px;
}

.image-box {
  width: 50rem;
  height: 30rem;
  background-color: #d1d1d1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #444;
}

.object-selection-container {
  width: 15rem;
  height: 30rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  font-weight: bold;
  color: #444;
  margin-bottom: 80px;
  padding: 1rem;
  box-sizing: border-box;
}

#object-selection-title {
  margin-bottom: 1rem;
  text-align: center;
  width: 100%;
}

.object-selection-box {
  width: 100%;
  overflow-y: auto;
}

.object-class-label {
  margin-bottom: 4px;
  font-weight: bold;
}

.object-item {
  padding-left: 8px;
  margin-bottom: 2px;
}

/* Bottom Section */
.bottom-section {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 1200px;
}

.box {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

button {
  background: #000000;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
}

button:hover {
  background: #303030;
}

button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.select {
  width: 80px;
  height: 25px;
  border: transparent;
}

/* Console Box */
.console {
  margin-top: 10px;
  background: #eee;
  padding: 10px;
  height: 120px;
  overflow-y: auto;
  font-size: 14px;
  border-radius: 5px;
  color: #333;
}

/* Responsive Design */
@media (max-width: 768px) {
  .image-container {
    flex-direction: column;
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
}


/* Mapbox styles */

.sidebar {
  background-color: rgb(35 55 75 / 90%);
  color: #fff;
  padding: 6px 12px;
  font-family: monospace;
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  margin: 12px;
  border-radius: 4px;
}

.reset-button {
  position: absolute;
  top: 50px;
  z-index: 1;
  left: 12px;
  padding: 4px 10px;
  border-radius: 10px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA,kBAAkB;;AAElB;EACE,qCAAqC;EACrC,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n.sub-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 20px;\n  background-color: #f5f5f5;\n  gap: 20px;\n}\n\n/* Upper Section */\n.image-container {\n  display: flex;\n  gap: 80px;\n  margin-bottom: 80px;\n}\n\n.image-box {\n  width: 50rem;\n  height: 30rem;\n  background-color: #d1d1d1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: #444;\n}\n\n.object-selection-container {\n  width: 15rem;\n  height: 30rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #fff;\n  font-weight: bold;\n  color: #444;\n  margin-bottom: 80px;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n#object-selection-title {\n  margin-bottom: 1rem;\n  text-align: center;\n  width: 100%;\n}\n\n.object-selection-box {\n  width: 100%;\n  overflow-y: auto;\n}\n\n.object-class-label {\n  margin-bottom: 4px;\n  font-weight: bold;\n}\n\n.object-item {\n  padding-left: 8px;\n  margin-bottom: 2px;\n}\n\n/* Bottom Section */\n.bottom-section {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.box {\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton {\n  background: #000000;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\nbutton:hover {\n  background: #303030;\n}\n\nbutton:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n}\n\n.select {\n  width: 80px;\n  height: 25px;\n  border: transparent;\n}\n\n/* Console Box */\n.console {\n  margin-top: 10px;\n  background: #eee;\n  padding: 10px;\n  height: 120px;\n  overflow-y: auto;\n  font-size: 14px;\n  border-radius: 5px;\n  color: #333;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .image-container {\n    flex-direction: column;\n  }\n  \n  .bottom-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* Mapbox styles */\n\n.sidebar {\n  background-color: rgb(35 55 75 / 90%);\n  color: #fff;\n  padding: 6px 12px;\n  font-family: monospace;\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 12px;\n  border-radius: 4px;\n}\n\n.reset-button {\n  position: absolute;\n  top: 50px;\n  z-index: 1;\n  left: 12px;\n  padding: 4px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
